import { authRequest } from './api/auth';

// Same value as TENANT in ./api/auth.js (not exported there)
const TENANT = 'tenant';

// The tenant prefix is added here because the auth.js interceptor only prefixes urls without "api"
const integration_url = (path) => {
    const tenant = window.localStorage.getItem(TENANT);
    return `/${tenant}/api/integration/${path}`;
};

// Full public URL of an integration API path (same base as BASE_URL in ./api/auth.js, which is not exported)
export const integration_full_url = (path) => {
    const tenant = window.localStorage.getItem(TENANT);
    const p = String(path || '').startsWith('/') ? path : `/${path || ''}`;
    return `${process.env.VUE_APP_API_BASE_URL}/${TENANT}/${tenant}${p}`;
};

class IntegrationService {
    list_agents() {
        return authRequest.get(integration_url('agents/'));
    }
    list_api_keys() {
        return authRequest.get(integration_url('api-keys/'));
    }
    create_api_key(data) {
        return authRequest.post(integration_url('api-keys/'), data);
    }
    update_api_key(id, data) {
        return authRequest.patch(integration_url(`api-keys/${id}/`), data);
    }
    delete_api_key(id) {
        return authRequest.delete(integration_url(`api-keys/${id}/`));
    }
    get_api_key_apis(id) {
        return authRequest.get(integration_url(`api-keys/${id}/apis/`));
    }
    save_api_key_apis(id, data) {
        return authRequest.put(integration_url(`api-keys/${id}/apis/`), data);
    }
    list_call_logs(params) {
        return authRequest.get(integration_url('call-logs/'), { params });
    }
    get_call_log(id) {
        return authRequest.get(integration_url(`call-logs/${id}/`));
    }
}

export default new IntegrationService();
